<template>
  <div :class="{ 'header-transparent-with-topbar': data.headerTransparency, 'floating-header-shell': data.navAlignment === 'left' }">
    <FloatingHeader ref="floatingHeader" @open-language="isLanguageModalOpen = true" v-if="data.navAlignment === 'left'" :show-theme-switcher="data.showThemeSwitcherButton" />
    <header v-else class="" :class="[`rn-header header-default header-not-transparent header-sticky ${data.headerClass}`]">
      <div class="container position-relative">
        <div class="row align-items-center row--0">
          <template v-if="data.navAlignment === 'right'">
            <div class="col-lg-3 col-md-6 col-4">
              <Logo />
            </div>

            <div class="col-lg-9 col-md-6 col-8 position-static">
              <div class="header-right">
                <nav class="mainmenu-nav d-none d-lg-block">
                  <Nav />
                </nav>
                <!-- PACKAGE disabled until the package page is ready -->
                <button type="button" :class="[data.buyButtonClass, 'btn-disabled']" disabled title="Coming soon">{{ $t('header.package') }}</button>

                <div class="mobile-menu-bar ml--5 d-block d-lg-none">
                  <div class="hamberger">
                    <button class="hamberger-button" @click.prevent="handleClick">
                      <Icon name="menu" size="21" />
                    </button>
                  </div>
                </div>

                <div v-if="data.showThemeSwitcherButton" id="my_switcher" class="my_switcher">
                  <ul>
                    <li>
                      <a href="javascript: void(0);" @click="handleClick">
                        <img class="light-icon" src="../../../assets/images/icons/sun-01.svg" alt="Sun" />
                        <img class="dark-icon" src="../../../assets/images/icons/vector.svg" alt="Moon" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </header>
    <MobileMenu v-if="data.navAlignment !== 'left'" />
    <Language :active="isLanguageModalOpen" @close="closeLanguageModal" />
    <div>
      <div class="rn-gradient-circle" />
      <div class="rn-gradient-circle theme-pink" />
    </div>
  </div>
</template>

<script>
import FloatingHeader from './FloatingHeader'
import Icon from '../../icon/Icon'
import MobileMenu from './MobileMenu'
import AppFunctions from '../../../helpers/AppFunctions'
import Nav from './Nav'
import Logo from '../../elements/logo/Logo'
import { usePiniaStore } from '../../../store/index'
import i18n from '../../../../i18n/i18n'
import { mapMutations } from 'vuex'
import Language from './Language.vue'

export default {
  name: 'Header',
  i18n,
  props: {
    data: {
      default: null,
      test: true,
      dropdownMenuButton: true
    }
  },
  components: { FloatingHeader, Logo, Nav, MobileMenu, Icon, Language },
  data() {
    return {
      isLanguageModalOpen: false,
      hasNewClass: false,
      AppFunctions,
      languageList: ['en', 'th', 'bn', 'cm', 'in', 'la', 'ml', 'mm', 'pp']
    }
  },
  methods: {
    closeLanguageModal() {
      this.isLanguageModalOpen = false
      this.$nextTick(() => {
        if (this.$refs.floatingHeader) this.$refs.floatingHeader.focusLanguageButton()
      })
    },
    toggleStickyHeader() {
      if (this.data.navAlignment === 'left') return
      const scrolled = document.documentElement.scrollTop
      if (scrolled > 100) {
        AppFunctions.addClass('.header-default', 'sticky')
      } else if (scrolled <= 100) {
        AppFunctions.removeClass('.header-default', 'sticky')
      }
    },
    // sendValueToStore() {
    //   const store = usePiniaStore()
    //   return store.setButtonValue('Value from button')
    // },
    // () {
    //   document.body.classList.toggle('active-light-mode') // เปลี่ยนคลาสให้เข้าหรือออก
    //   this.checkBodyClass() // เรียกเมธอดเพื่อตรวจสอบคลาส
    // },
    // checkBodyClass() {
    //   this.hasNewClass = document.body.classList.contains('active-light-mode')
    // },
    handleClick() {
      this.$store.commit('dataLogin', !this.userLogin) // สลับค่า state ใน Vuex store
    },

    testclick() {
      this.$store.commit('dataLogin', !this.userLogin)
    },
    ...mapMutations(['setLocale']),
    changeLanguage(locale) {
      this.setLocale(locale)
      this.$i18n.locale = locale // เปลี่ยน locale ใน i18n
    },

    isLanguageAvailable(locale) {
      return !!this.$i18n.messages[locale]
    }
  },

  computed: {
    userLogin() {
      return this.$store.state.userLogin
    }
  },
  created() {
    window.addEventListener('scroll', this.toggleStickyHeader)
  },
  mounted() {
    this.toggleStickyHeader()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.toggleStickyHeader)
  }
  // toggleLanguage(locale) {
  //   i18n.locale = locale
  // }
}
</script>
<style>
.large-dropdown {
  width: 100vw;
  /* ปรับขนาดตามความต้องการ */
  font-size: 20px;
  /* translate: transform(10%, 100%); ปรับขนาดตามความต้องการ */
}

.background-dropdown {
  background-image: url(../../../assets/images/Newlandindpage/path/bg_topbar_dark.png);
  background-size: cover;
  background-position: -50% 20%;
  width: 100vw;
  height: 100vh;
}

.background-dropdown-2 {
  background-image: url(/img/bg_topbar.375c5271.png);
  background-size: cover;
  background-position: -50% 80%;
  width: 100vw;
  height: 100vh;
}

.flex-center-item-list {
  transform: translate(10%, 100%);
}

.font-header {
  font-size: 26px;
}

.path-112 {
  transform: translate(0%, 60%);
}

.not-allowed {
  cursor: not-allowed;
}

.bg-font-2 {
  opacity: 0.5;
  cursor: not-allowed;
}

@media only screen and (max-width: 991px) {
  .large-dropdown {
    width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
    font-size: 16px;
    left: 0 !important;
    right: 0 !important;
    position: fixed !important;
    top: 0 !important;
    height: 100vh !important;
    border-radius: 0 !important;
    overflow-y: auto;
    z-index: 1000;
  }

  .background-dropdown,
  .background-dropdown-2 {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background-position: center;
    padding: 60px 20px !important;
  }

  .flex-center-item-list {
    transform: translate(0, 0);
    padding: 20px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100%;
  }

  .font-header {
    font-size: 22px;
    display: block;
    padding: 15px 0;
  }

  .large-dropdown .container {
    padding: 0 !important;
    max-width: 100%;
  }

  .large-dropdown .row {
    margin: 0;
  }

  .large-dropdown .row [class*="col-"] {
    margin-bottom: 20px;
    text-align: center;
  }
}
</style>
